/*
  maiocchi-video-sound.js  -  July 2026

  TWO KINDS OF VIDEO, TWO BEHAVIOURS

    SHORT CLIP (4-19s) - a model turning. No narration. Loops, stays SILENT. Like a reel.
                         This script leaves it completely alone.

    TALK-THROUGH (55-183s) - Dee talking to camera. Does not loop, and starts WITH SOUND,
                         because the sound is the entire content.

  snippets/media.liquid decides which is which from the video's length and marks the
  <deferred-media> element with data-video-kind. Nothing to tag by hand.

  THE PROBLEM THIS SOLVES
  Dee's talk-throughs were starting silent, and the only remedy was the browser's own ~20px
  mute icon, which almost nobody finds. A talk-through on mute is just a woman moving her mouth.

  WHY THEY STARTED MUTED - not the theme's fault. Every browser since ~2018 blocks autoplay
  WITH sound, so when the theme asked media_tag for autoplay it automatically added `muted`.

  THE LOOPHOLE - our videos don't autoplay on page load. They only exist once the shopper TAPS
  the play button (Shopify's deferred-media pattern). That tap is a user gesture, and a user
  gesture unlocks audio. She pressed play, so she is allowed to hear it.

  SAFETY - if a browser refuses sound anyway, we fall back to MUTED playback rather than nothing,
  and the native controls are always there. No path here ends in a dead button.
*/
(function () {
  var POLL_MS = 50;
  var MAX_TRIES = 60;   // 3 seconds - ample for the <template> to be cloned in

  function unmuteAndPlay(video) {
    if (!video || video.dataset.maiocchiSoundOn) return;
    video.dataset.maiocchiSoundOn = '1';

    video.muted = false;
    video.removeAttribute('muted');
    video.volume = 1;

    var attempt = video.play();

    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        // Browser wouldn't allow sound. Better a silent video than a frozen one.
        video.muted = true;
        var retry = video.play();
        if (retry && typeof retry.catch === 'function') {
          retry.catch(function () { /* controls are visible - she can press play herself */ });
        }
      });
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var button = target.closest('[data-deferred-media-button]');
    if (!button) return;

    var host = button.closest('deferred-media');
    if (!host) return;

    // Short clips loop silently and want no interference. Leave them be.
    if (host.getAttribute('data-video-kind') === 'short-clip') return;

    // The video doesn't exist yet - the theme clones it out of a <template> on tap.
    // Watch for it, then take the sound off.
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      var video = host.querySelector('video');

      if (video) {
        clearInterval(poll);
        unmuteAndPlay(video);
      } else if (tries >= MAX_TRIES) {
        clearInterval(poll);
      }
    }, POLL_MS);
  }, true);
})();
